const prop = 'language';
const defaultLanguage = 'pt';
const languages = {
  'pt': 'pt-PT',
  'en': 'en'
};

if (!localStorage.getItem(prop)) {
  localStorage.setItem(prop, defaultLanguage);
}

export const getLanguage = () => {
  const selectLanguage = localStorage.getItem(prop);
  if (selectLanguage) {
    return languages[selectLanguage];
  } else {
    return defaultLanguage;
  }
};

export const setLanguage = (language) => {
  if (languages[language]) {
    localStorage.setItem(prop, language);
  } else {
    localStorage.setItem(prop, defaultLanguage);
  }
};

export const getDefaultLanguage = () => {
  return defaultLanguage;
};



// WEBPACK FOOTER //
// ./src/language.js